import { IQuyDinhSoBuoiTrenTuanActionTypes } from "../../action-types/category/IQuyDinhSoBuoiTrenTuanActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IQuyDinhSoBuoiTrenTuanReducer } from "../../reducer-model/category/IQuyDinhSoBuoiTrenTuanReducer";

const initState: IQuyDinhSoBuoiTrenTuanReducer = {
  status: eReducerStatusBase.is_not_initialization,
  quyDinhSoBuoiTrenTuans: [],
};
export const quyDinhSoBuoiTrenTuanReducer = (
  state: IQuyDinhSoBuoiTrenTuanReducer = initState,
  action: IQuyDinhSoBuoiTrenTuanActionTypes
): IQuyDinhSoBuoiTrenTuanReducer => {
  switch (action.type) {
    case "QUY_DINH_SO_BUOI_TREN_TUAN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "QUY_DINH_SO_BUOI_TREN_TUAN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        quyDinhSoBuoiTrenTuans: action.payload,
      };
    case "QUY_DINH_SO_BUOI_TREN_TUAN_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "QUY_DINH_SO_BUOI_TREN_TUAN_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        quyDinhSoBuoiTrenTuanEditing: action.payload,
      };
    case "QUY_DINH_SO_BUOI_TREN_TUAN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "QUY_DINH_SO_BUOI_TREN_TUAN_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "QUY_DINH_SO_BUOI_TREN_TUAN_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "QUY_DINH_SO_BUOI_TREN_TUAN_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "QUY_DINH_SO_BUOI_TREN_TUAN_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "QUY_DINH_SO_BUOI_TREN_TUAN_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "QUY_DINH_SO_BUOI_TREN_TUAN_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
